import { defineStore } from "pinia";
import { ref } from "vue";
import type { PlanLimitInfo } from "core-fe-lib/components-shadcn/composables/planLimit";

// Drives the contextual upgrade dialog (ADR 024). Opened either reactively from
// a 402 PLAN_LIMIT_REACHED (via the core-fe-lib planLimit bridge) or
// proactively from a usage meter near/over its cap.
export const usePlanLimitStore = defineStore("plan-limit", () => {
  const open = ref(false);
  const info = ref<PlanLimitInfo | null>(null);

  function openFor(i: PlanLimitInfo) {
    info.value = i;
    open.value = true;
  }
  function close() {
    open.value = false;
  }

  return { open, info, openFor, close };
});
